import { useInstance } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
import { isNullOrUndefined } from 'intact-shared';
import { isGT, isLT, last } from './helpers';
import { PanelFlags, PanelTypes } from './usePanel';
export function useDisabled(_ref) {
  var createDateByValueFormat = _ref.createDateByValueFormat;
  var instance = useInstance();
  var maxDate = useState(null);
  var minDate = useState(null);
  function convertToDayjs(state, v) {
    if (isNullOrUndefined(v)) {
      state.set(null);
    } else {
      state.set(createDateByValueFormat(v));
    }
  }
  instance.on('$receive:max', function (v) {
    convertToDayjs(maxDate, v);
  });
  instance.on('$receive:min', function (v) {
    convertToDayjs(minDate, v);
  });
  function isDisabled(value, type) {
    if (type === void 0) {
      type = 'date';
    }
    var _instance$get = instance.get(),
      disabledDate = _instance$get.disabledDate;
    return isGT(value, maxDate.value, type) || isLT(value, minDate.value, type) || !!disabledDate && disabledDate(value);
  }
  function isDisabledTime(value, flag) {
    if (!isDisabled(value, 'second')) {
      if (!instance.get('range')) return false;
      // compare the start and the end datetime 
      var anotherDatetime = instance.value.getTimeValue(flag === PanelFlags.Start ? PanelFlags.End : PanelFlags.Start);
      if (!anotherDatetime) return false;
      if (flag === PanelFlags.Start) {
        return value.isAfter(anotherDatetime, 'second');
      } else {
        return value.isBefore(anotherDatetime, 'second');
      }
    }
    return true;
  }
  function isDisabledConfirm() {
    var lastValue = last(instance.value.value.value);
    if (!lastValue) return true;
    var _instance$get2 = instance.get(),
      range = _instance$get2.range;
    if (range && lastValue.length < 2) return true;
    var _instance$panel = instance.panel,
      startPanel = _instance$panel.startPanel,
      endPanel = _instance$panel.endPanel;
    if (startPanel.value === PanelTypes.Date && endPanel.value === PanelTypes.Date) {
      return true;
    }
    var start;
    var end;
    if (range) {
      start = lastValue[0];
      end = lastValue[1];
    } else {
      start = lastValue;
    }
    if (isDisabledTime(start, PanelFlags.Start) || end && isDisabledTime(end, PanelFlags.End)) {
      return true;
    }
    return false;
  }
  return {
    isDisabled: isDisabled,
    isDisabledTime: isDisabledTime,
    isDisabledConfirm: isDisabledConfirm,
    maxDate: maxDate,
    minDate: minDate
  };
}